
import React from 'react';

export enum PageType {
    item = "item",
    group = "group",
    collapse = "collapse"
}

export interface PagePathChipSetting {
    color?: 'default' | 'primary' | 'secondary';
    variant?: 'default' | 'outlined';
    size?: 'small' | 'medium';
    label?: React.ReactNode;
    avatar?: React.ReactNode;
}

export type PagePathIcon = React.ElementType<{
    stroke?: number;
    size?: string;
    className?: string;
}>;

export type PagePathComponent =
    | React.ElementType
    | React.LazyExoticComponent<React.ComponentType<unknown>>;

export default class PagePath {
    label: string = "";
    content: PagePath[] = [];
    to: string | undefined = undefined;
    icon?: PagePathIcon | null;
    Component?: PagePathComponent | null;
    description: string = "";
    ShowInNavbar: boolean = true;
    IsStandAlone: boolean = false;
    type: PageType = PageType.item;
    IsDisabled: boolean = false;
    chip: PagePathChipSetting | null = null;
    LocalePath: string = "";

    constructor(Text: string, Path: string | undefined, Icon: PagePathIcon | null,
        Component: PagePathComponent | null,
        LocalePath: string = "", Description: string = "", ShowInNavbar = true, IsStandAlone = false,
        type: PageType = PageType.item, IsDisabled = false, chip: PagePathChipSetting | null = null) {
        this.label = Text;
        this.to = Path;
        this.icon = Icon;
        this.Component = Component;
        this.description = Description;
        this.ShowInNavbar = ShowInNavbar;
        this.description = Description;
        this.IsStandAlone = IsStandAlone;
        this.type = type;
        this.IsDisabled = IsDisabled;
        this.chip = chip;
        this.LocalePath = LocalePath ? LocalePath : Text
    }


    public static GetFlatFromRecursive(allPath: PagePath[]): PagePath[] {
        var allItems: PagePath[] = [];

        if (!allPath?.length) {
            return [];
        }

        for (let i = 0; i < allPath.length; i++) {
            const item = allPath[i];

            allItems.push(item);
            allItems = allItems.concat(PagePath.GetFlatFromRecursive(item.content));
        }

        return allItems;
    }

}